// ============================================================
// EDITABLE CONTENT — Change text, images, and details here.
// ============================================================

export const BRAND = {
  name: "TANGENSIS",
  full: "TANGENSIS BUSINESS SOLUTIONS",
  tagline: "BUSINESS SOLUTIONS",
  logo: "/tbs-logo-mark.png",
};

export const NAV_LINKS = [
  { label: "HOME", path: "/" },
  { label: "ABOUT", path: "/about" },
  { label: "SERVICES", path: "/services" },
  { label: "PROJECTS", path: "/projects" },
  { label: "CONTACT", path: "/contact" },
];

export const CONTACT_INFO = {
  email: "Contact@tangensis.co", // e.g. hello@tangensis.com
  phone: "+91-9494010107", // e.g. +1 (000) 000-0000
  address: "Shree Krishna Homes, NH 44, Kompally, Secunderabad, Telangana 500078",
  hours: "Mon – Fri, 9:00 – 18:00",
  socials: [
    { label: "LinkedIn", url: "#" },
    { label: "Instagram", url: "#" },
    { label: "X / Twitter", url: "#" },
    { label: "Dribbble", url: "#" },
  ],
};

export const SERVICES = [
  {
    num: "01",
    slug: "digital-transformation",
    title: "Digital Transformation",
    short: "Modernize operations, systems and culture to compete in a digital-first world.",
    capabilities: ["Digital maturity assessment", "Technology strategy", "Automation & workflows", "Change enablement"],
    benefits: ["Reduced operational friction", "Scalable infrastructure", "Future-ready teams"],
  },
  {
    num: "02",
    slug: "process-optimization",
    title: "Process Optimization",
    short: "We remove friction and design lean, measurable processes that scale with you.",
    capabilities: ["Process mapping", "Bottleneck analysis", "Lean & efficiency design", "Performance metrics"],
    benefits: ["Lower cost to operate", "Higher throughput", "Consistent quality"],
  },
  {
    num: "03",
    slug: "talent-acquisition-consulting",
    title: "Talent Acquisition & Consulting",
    short: "End-to-end IT staffing and talent acquisition across the USA, UK, Australia, UAE and India — connecting you with the right people, fast.",
    capabilities: ["IT staffing (contract, C2H & permanent)", "Global talent sourcing across USA, UK, Australia, UAE & India", "Executive & niche-tech search", "Onboarding & workforce consulting"],
    benefits: ["Access to a vetted global talent pool", "Faster time-to-hire", "Reduced hiring risk and cost"],
  },
  {
    num: "04",
    slug: "technology-solutions",
    title: "Technology Solutions",
    short: "From architecture to delivery, we build the technology that powers growth.",
    capabilities: ["Solution architecture", "Product & platform builds", "Data & analytics", "Integration"],
    benefits: ["Reliable systems", "Actionable data", "Faster delivery"],
  },
  {
    num: "05",
    slug: "erp-solutions",
    title: "ERP Solutions",
    short: "Enterprise Resource Planning implementation and consulting across leading platforms like Oracle and SAP.",
    capabilities: ["Oracle & SAP implementation", "ERP consulting & advisory", "Migration & integration", "Process optimization"],
    benefits: ["Unified business processes", "Real-time enterprise visibility", "Lower operational overhead"],
  },
];

// Full services page list
export const SERVICES_FULL = [...SERVICES];

export const PROJECTS = [
  {
    id: "01",
    slug: "digital-transformation",
    title: "Digital Transformation",
    category: "DIGITAL",
    tag: "digital",
    year: "2025",
    excerpt: "Modernizing operations and customer experience to build agile, future-ready businesses.",
    image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    metrics: [
      { value: "42%", label: "Faster process cycle times" },
      { value: "3.2x", label: "Increase in digital adoption" },
      { value: "28%", label: "Lower operational costs" },
    ],
    client: "Global manufacturing group",
    duration: "9 months",
    overview: "At Tangensis Business Solutions, we help organizations embrace digital transformation by connecting business objectives with practical technology solutions. Our approach focuses on modernizing operations, improving customer experiences, strengthening digital capabilities, and creating more agile business environments. We work with organizations across the USA, UK, UAE, Australia, India, Canada, Malaysia, and Singapore, helping them adapt to changing market demands and build sustainable digital foundations.",
    challenge: "Many organizations carry legacy systems, fragmented tools and manual workflows that slow decision-making and limit their ability to respond to shifting market demands. The real challenge is modernizing without disrupting day-to-day operations.",
    strategy: "We begin with a clear assessment of digital maturity — mapping systems, data flows and capabilities against business objectives — then prioritize the initiatives that deliver the greatest impact through a phased, low-risk roadmap.",
    solution: "Tangensis modernizes core operations, streamlines customer touchpoints and introduces automation where it matters most, while enabling teams to adopt new ways of working with confidence.",
    results: ["More agile, connected operations", "Improved customer and employee experience", "A scalable digital foundation for future growth"],
    gallery: [
      "https://images.unsplash.com/photo-1705615791240-c35f4799863b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1604528935023-74e0a7b2d23f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
  {
    id: "02",
    slug: "business-growth-strategy",
    title: "Business Growth Strategy",
    category: "STRATEGY",
    tag: "strategy",
    year: "2025",
    excerpt: "Data-led growth strategies that turn market opportunity into durable, measurable revenue.",
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    metrics: [
      { value: "+37%", label: "Year-over-year revenue growth" },
      { value: "5", label: "New market segments entered" },
      { value: "2.4x", label: "Return on strategy investment" },
    ],
    client: "Growth-stage services firm",
    duration: "6 months",
    overview: "We develop business growth strategies designed around each organization's goals, market position, and growth potential. Our focus is on identifying new opportunities, strengthening existing business models, improving operational performance, and creating clear pathways for sustainable expansion. At Tangensis Business Solutions, we combine business insight with practical execution to help organizations make informed decisions and pursue measurable growth across local and international markets.",
    challenge: "Growth ambitions often stall when strategy is disconnected from execution, or when opportunities are pursued without a clear view of market position and the capacity to deliver.",
    strategy: "We combine market insight with a candid assessment of the business model to identify the highest-value opportunities, then define clear, measurable pathways to pursue them.",
    solution: "Tangensis translates strategy into an actionable plan — sharpening the value proposition, strengthening existing revenue streams and sequencing initiatives so momentum compounds over time.",
    results: ["A clear, prioritized growth roadmap", "Stronger, more resilient revenue streams", "Confident, evidence-based decision-making"],
    gallery: [
      "https://images.unsplash.com/photo-1688380692117-63178554d76d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
  {
    id: "03",
    slug: "process-optimization",
    title: "Process Optimization",
    category: "TRANSFORMATION",
    tag: "transformation",
    year: "2024",
    excerpt: "Lean, scalable processes engineered for speed, consistency and a lower cost to operate.",
    image: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    metrics: [
      { value: "55%", label: "Reduction in manual handoffs" },
      { value: "31%", label: "Faster decision-making" },
      { value: "99.2%", label: "Process consistency achieved" },
    ],
    client: "Regional logistics operator",
    duration: "5 months",
    overview: "Efficient processes are essential for businesses seeking consistent performance and long-term growth. Tangensis Business Solutions helps organizations identify process gaps, eliminate unnecessary complexity, improve workflows, and enhance resource utilization. Our objective is to create streamlined and scalable processes that support better productivity, faster decision-making, improved service delivery, and stronger overall business performance.",
    challenge: "As organizations scale, processes accumulate complexity — duplicated effort, unclear ownership and bottlenecks that quietly erode productivity and margin.",
    strategy: "We map how work actually flows, pinpoint the gaps and bottlenecks, and redesign processes around clarity, efficiency and measurable performance.",
    solution: "Tangensis removes unnecessary complexity, streamlines workflows and improves resource utilization to create processes that stay efficient as the business grows.",
    results: ["Faster, more reliable decision-making", "Higher productivity and service quality", "Streamlined, scalable operations"],
    gallery: [
      "https://images.unsplash.com/photo-1686061592689-312bbfb5c055?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
  {
    id: "04",
    slug: "technology-consulting",
    title: "Technology Consulting",
    category: "CONSULTING",
    tag: "consulting",
    year: "2024",
    excerpt: "Aligning technology investment — from AI to ERP — with real business priorities and value.",
    image: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    metrics: [
      { value: "34%", label: "Reduction in IT spend" },
      { value: "6 wk", label: "To a clear tech roadmap" },
      { value: "2x", label: "Faster delivery cadence" },
    ],
    client: "Enterprise financial services",
    duration: "4 months",
    overview: "Our technology consulting services help businesses understand where technology can create meaningful business value. We assess organizational requirements, identify suitable technology opportunities, and support businesses in developing practical technology strategies. From improving existing systems to planning technology-driven initiatives, Tangensis Business Solutions focuses on solutions that align technology investments with business priorities, operational needs, and future growth.",
    challenge: "Technology decisions are often driven by trends rather than value, leaving organizations with tools that don't align to their priorities, operational needs or growth plans.",
    strategy: "We start with the business, not the technology — assessing requirements and identifying where technology, including AI and enterprise platforms, can create meaningful, measurable value.",
    solution: "Tangensis helps develop a practical technology strategy: improving existing systems, planning technology-driven initiatives and aligning every investment with business priorities and future growth.",
    results: ["Technology investments tied to business value", "A clear, practical technology roadmap", "Reduced risk and stronger returns on IT spend"],
    gallery: [
      "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1697577418970-95d99b5a55cf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
  {
    id: "05",
    slug: "market-expansion",
    title: "Market Expansion",
    category: "STRATEGY",
    tag: "strategy",
    year: "2023",
    excerpt: "Research-led market entry and international expansion across four continents.",
    image: "https://images.unsplash.com/photo-1733195296321-b99d129b09cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    metrics: [
      { value: "4", label: "New countries launched" },
      { value: "18%", label: "First-year market share" },
      { value: "60%", label: "Lower entry risk exposure" },
    ],
    client: "International technology brand",
    duration: "12 months",
    overview: "Tangensis Business Solutions supports organizations looking to enter new markets and strengthen their international presence. We help businesses evaluate market opportunities, understand regional business environments, identify potential growth areas, and develop strategies for sustainable expansion. With our operational reach across the USA, UK, UAE, Australia, India, Canada, Malaysia, and Singapore, we provide a broader perspective for organizations seeking to establish or expand their presence across international markets.",
    challenge: "Entering new markets brings unfamiliar regulations, competitive dynamics and customer expectations — where a single misjudged assumption can be costly.",
    strategy: "We evaluate market opportunities and regional business environments, identify the most promising growth areas and design a sustainable, well-sequenced expansion strategy.",
    solution: "With operational reach across the USA, UK, UAE, Australia, India, Canada, Malaysia and Singapore, Tangensis brings a broader perspective to help organizations establish and expand their international presence.",
    results: ["Informed, de-risked market entry", "A clear playbook for sustainable expansion", "A stronger international presence and reach"],
    gallery: [
      "https://images.unsplash.com/photo-1676588160170-778542c7072b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "https://images.unsplash.com/photo-1576185850227-1f72b7f8d483?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    ],
  },
];

export const PROJECT_FILTERS = ["ALL", "STRATEGY", "DIGITAL", "CONSULTING", "TRANSFORMATION"];

export const DIFFERENTIATORS = [
  { num: "01", title: "STRATEGIC", text: "We connect business objectives with actionable strategies that drive real momentum." },
  { num: "02", title: "INNOVATIVE", text: "We identify smarter ways to solve complex business challenges others overlook." },
  { num: "03", title: "PRACTICAL", text: "Our solutions are designed for real-world implementation, not just theory." },
  { num: "04", title: "RESULTS-DRIVEN", text: "We focus on measurable outcomes rather than ideas alone." },
  { num: "05", title: "CLIENT-CENTRIC", text: "Every solution is tailored to the organization and the people within it." },
];

export const APPROACH = [
  { phase: "01", title: "DISCOVER", text: "Understand the business, its challenges, goals and opportunities in depth." },
  { phase: "02", title: "STRATEGIZE", text: "Develop a focused strategy tightly aligned with business objectives." },
  { phase: "03", title: "IMPLEMENT", text: "Turn strategy into practical solutions and measurable action." },
  { phase: "04", title: "OPTIMIZE", text: "Measure results, refine the approach and create sustainable growth." },
];

export const STATS = [
  { value: 8, suffix: "+", label: "YEARS OF EXPERIENCE" },
  { value: 25, suffix: "+", label: "HAPPY CONSUMERS" },
  { value: 5, suffix: "", label: "COUNTRIES SERVED" },
  { value: 100, suffix: "%", label: "COMMITMENT TO CLIENTS" },
];

export const TESTIMONIALS = [
  { quote: "Tangensis reframed our biggest obstacle into our clearest opportunity. The strategy was sharp and the execution flawless.", name: "Managing Director", company: "Enterprise Client", role: "Manufacturing" },
  { quote: "They combine the ambition of a creative agency with the rigor of a top consulting firm. Rare and invaluable.", name: "Chief Operating Officer", company: "Enterprise Client", role: "Financial Services" },
  { quote: "Measurable impact from week one. Tangensis moved our business forward faster than we thought possible.", name: "VP, Technology", company: "Enterprise Client", role: "Retail & Distribution" },
  { quote: "A genuine partner. They cared about outcomes as much as we did, and it showed in the results.", name: "Founder & CEO", company: "Growth-stage Client", role: "Technology" },
];

export const VALUES = [
  { title: "Innovation", text: "We pursue smarter, bolder ways of solving problems." },
  { title: "Integrity", text: "We do what's right, even when it's not the easiest path." },
  { title: "Collaboration", text: "We win together — with our clients and each other." },
  { title: "Excellence", text: "We hold every detail to an uncompromising standard." },
  { title: "Impact", text: "We measure ourselves by the outcomes we create." },
];

export const SERVICE_OPTIONS = [
  "Digital Transformation",
  "Process Optimization",
  "Talent Acquisition & Consulting",
  "Technology Solutions",
  "ERP Solutions (Oracle / SAP)",
  "Other",
];
